import "./EllipsisText.css";

interface EllipsisTextProps {
  text: string | number;
  length?: number;
  underline?: boolean | null;
}

const EllipsisText: React.FC<EllipsisTextProps> = ({
  text,
  length = 26,
  underline,
}) => {
  const classNames = `ellipsis-text ${underline ? "underline" : ""}`;

  // Convert text to string to handle both numbers and strings
  const textStr = String(text);

  if (textStr.length <= length) {
    return (
      <span className={classNames} title={textStr}>
        {text}
      </span>
    );
  }

  return (
    <span className={classNames} title={textStr}>
      {textStr.substring(0, length)}...
    </span>
  );
};

export default EllipsisText;
